/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_RoundInputs */



/**
* | output |
* | --- |
* | "Round" |
*
* @param {Sanction_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_round = /** @type {((inputs?: Sanction_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round")
	return /** @type {LocalizedString} */ ("Round")
});